import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";

export class SendSMSDTO extends Record {
    constructor(ToNumber, Message) {
        super();
        this.ToNumber = ToNumber;
        this.Message = Message;
    }
}

export function SendSMSDTO$reflection() {
    return record_type("Containers.SendSMS.Model.SendSMSDTO", [], SendSMSDTO, () => [["ToNumber", string_type], ["Message", string_type]]);
}

